import React, { useState, useCallback } from 'react';
import i18next from 'i18next';
import { Repeat, RepeatTiny } from '../../../StyledComponents/Repeat';
import { VisualHeading } from '../../../StyledComponents/Heading';
import OptionBox from '../../../StyledComponents/OptionBox';
import { OptionBoxHeading, OptionBoxContent } from '../../../StyledComponents/OptionBox/wrapper';
import { ButtonInline } from '../../../StyledComponents/Button';
import { InsuranceOption, Branch } from '../../../@types/codegen/types';
import InsuranceModal from './InsuranceModal';

interface InsuranceOptions {
  id: string;
  branch?: Branch | null;
  insuranceOptions: InsuranceOption[];
}

const Insurance = ({ id, branch, insuranceOptions }: InsuranceOptions) => {
  const [modal, setModal] = useState(false);
  const toggleModal = useCallback(() => setModal(!modal), [modal]);
  if (!insuranceOptions.length) {
    return null;
  }

  return (
    <>
      {modal && (
        <InsuranceModal
          id={id}
          branch={branch}
          onClose={toggleModal}
          insuranceOptions={insuranceOptions[0]}
        />
      )}
      <Repeat>
        <RepeatTiny>
          <VisualHeading>{i18next.t('item.addInsurance')}</VisualHeading>
        </RepeatTiny>
        <RepeatTiny>
          <>
            {insuranceOptions.map((insuranceOption, index) => (
              <OptionBox
                key={`${insuranceOption.url}-${index}`}
                logo={insuranceOption.logotype || undefined}
                logoAlt={insuranceOption.name || i18next.t('common.logotype') || ''}
              >
                <OptionBoxHeading>{i18next.t('item.getInsuranceQuote')}</OptionBoxHeading>
                <OptionBoxContent>
                  <p>
                    <ButtonInline
                      onClick={toggleModal}
                      title={i18next.t('common.moreInformation') || ''}
                    >
                      {i18next.t('common.moreInformation')}
                    </ButtonInline>
                  </p>
                </OptionBoxContent>
              </OptionBox>
            ))}
          </>
        </RepeatTiny>
      </Repeat>
    </>
  );
};

export default Insurance;
